var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1b40b2e2feec8da482dca1834209ff21827079dc"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs"
import { isInjectedBridgeError } from "./src/lib/sentry/injected-bridge-filter"
import { browserSentryEnvironment, isHeadlessBrowser } from "./src/lib/sentry/environment"

// Vercel-pulled env values can carry a trailing "\n"; a DSN with one is
// malformed, so Sentry silently disables itself and nothing is ever reported.
const clean = (v?: string) => (v || '').replace(/\\n$/g, '').replace(/\n$/g, '').trim()

Sentry.init({
  dsn: clean(process.env.NEXT_PUBLIC_SENTRY_DSN),
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.5,
  enabled: process.env.NODE_ENV === 'production',
  // From the host the page is on: process.env.VERCEL_ENV is not exposed to
  // browser code, so every browser error (staging's too) read "production".
  // Only staging and local hosts change; every other host stays "production"
  // as before (a build-time value could read "preview" on a deployment that
  // was promoted without a rebuild, and drop real errors out of alerts).
  environment: browserSentryEnvironment(
    typeof window !== 'undefined' ? window.location.hostname : '',
    process.env.NODE_ENV,
  ),
  ignoreErrors: [
    'ResizeObserver loop',
    'Non-Error promise rejection',
    'AbortError',
    'ChunkLoadError',
    // Instagram/Facebook/TikTok in-app browsers inject their own bridge script
    // and it throws inside their wrapper, not our page. Nothing we can fix, and
    // it drowns out real errors on a link that gets shared to social.
    'window.webkit.messageHandlers',
    'sendDataToNative',
    'sendPageHideMessage',
    // Instagram iOS webview autofill shim referencing a missing native handler
    '_AutofillCallbackHandler',
    // Facebook Android webview perf logger losing its bridge on navigation
    'Java object is gone',
    '_pcmBridgeCallbackHandler',
  ],
  // ignoreErrors above matches the MESSAGE. Instagram's injected login-field
  // sniffer throws a generic `InvalidAccessError` we cannot blanket-suppress,
  // and it runs in our page with no source file so Sentry blames us. What
  // identifies it is the STACK (dispatchToBridge etc.), so filter on frames.
  beforeSend(event) {
    // Headless browsers (scrapers, probes, our own QA runs) are not buyers.
    if (typeof navigator !== 'undefined' && isHeadlessBrowser(navigator.userAgent)) return null
    return isInjectedBridgeError(event) ? null : event
  },
})
